import React from 'react';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

export const FullPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(2)}px;
  padding: ${(props) => props.theme.spacing(1)}px;
  width: calc(100% - ${(props) => props.theme.spacing(3)}px * 2);
`;

export const HalfPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(2)}px 0
    ${(props) => props.theme.spacing(2)}px
    ${(props) => props.theme.spacing(2)}px;
  padding: ${(props) => props.theme.spacing(1)}px;
  width: calc(100% - ${(props) => props.theme.spacing(3)}px * 2);

  overflow: hidden;
  @media screen and (min-width: ${(props) =>
      props.theme.breakpoints.values.sm}px) {
    width: calc(50% - ${(props) => props.theme.spacing(3)}px * 2);
  }
`;

export const QuarterPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(2)}px 0
    ${(props) => props.theme.spacing(2)}px
    ${(props) => props.theme.spacing(2)}px;
  padding: ${(props) => props.theme.spacing(1)}px;
  width: calc(100% - ${(props) => props.theme.spacing(3)}px * 2);
  overflow: hidden;
  @media screen and (min-width: ${(props) =>
      props.theme.breakpoints.values.sm}px) {
    width: calc(25% - ${(props) => props.theme.spacing(3)}px * 2);
  }
`;

export const FlexWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const FlatFullPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(2)}px;
  width: calc(100% - ${(props) => props.theme.spacing(2)}px * 2);
  box-shadow: none;
`;

export const FlexWrapCenter = styled.div`
  justify-content: center;
  width:100%;
  display: flex;
  flex-wrap: wrap;
`

export const StyledFullPaper = styled(Paper)`
  margin:${props => props.theme.spacing(2)}px;
  padding:${props => props.theme.spacing(1)}px;
  width:calc( 100% - ${props => props.theme.spacing(3)}px * 2);

  @media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px){
    padding: 0;
    margin:0;
    box-shadow: none;
    width:calc( 100% - ${props => props.theme.spacing(1)}px * 2);
    margin: ${props => props.theme.spacing(1)}px;
    margin-bottom:${props => props.theme.spacing(8)}px;
  }
`;

export const StyledFlexWrap = styled.div`
  width:100%;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px){
    padding: 0;
  }
`;

export const StyledHalfFlexWrap = styled.div`
width: 682px;
display: flex;
flex-wrap: wrap;
@media screen and (max-width: 1000px){
  width: 100%
}
`;

export const QuarterStyledePaper = styled(Paper)`
width : 375px;
box-shadow: none;
padding: 0;
margin:${props => props.theme.spacing(2)}px;
padding:${props => props.theme.spacing(1)}px;
width:calc( 100% - ${props => props.theme.spacing(3)}px * 2);
@media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px){
  padding: 0;
  width : 375px;
  margin:0;
  box-shadow: none;
  margin-bottom:${props => props.theme.spacing(8)}px;
}
`;

export const CenteredPaper = styled(Paper)`
width : 486px;
height: 500px;
box-shadow: none;
border-radius: 4px;
text-align:center;
border: solid 1px #DADCE0;
margin: 150px auto auto auto;
@media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px){
  padding: 0;
  width : 100vw;
  marign: 0;
  border:none;
  height: auto;
}
`;



